import CryptoJS from 'crypto-js'

const initKey = '682864A5'

// 加密
export function encrypt(message, key = initKey) {
    let srcs = CryptoJS.enc.Utf8.parse(key)
    let encrypted = CryptoJS.DES.encrypt(message, srcs, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7})
    return encrypted.ciphertext.toString()
}

// 解密
export function decrypt(message, key = initKey) {
    let keyHex = CryptoJS.enc.Utf8.parse(key)
    let decrypted = CryptoJS.DES.decrypt({
        ciphertext: CryptoJS.enc.Hex.parse(message)
    }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
}